import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'item', 'mobileItem', 'button' ];

	load(e) {
        e.preventDefault();
        var count = 1;

        this.itemTargets.forEach((element) => {

            if(element.classList.contains('hidden') && count <= 9) {

                element.classList.remove('hidden');

                count++;
            }

        });

        var count = 1;
        this.mobileItemTargets.forEach((element) => {

            if(element.classList.contains('hidden') && count <= 9) {

                element.classList.remove('hidden');

                count++;
            }

        });

        if(count < 9) {

            this.buttonTargets.forEach((element) => {
                element.classList.add('hidden');
            });
        }
    }
}
